/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import cn from 'clsx';
import { SearchOutlined } from '@ant-design/icons';
import { getDateWithFormat, getMomentDate } from 'util/date';
import { ReactComponent as ReviewAcceptSvg } from 'assets/icons/New/ReviewAccept.svg';
import { ReactComponent as ReviewRejectSvg } from 'assets/icons/New/ReviewReject.svg';
import { ReactComponent as ExternalSvg } from 'assets/icons/New/External.svg';
import { AModal, AButton, AInput, ACheckbox, ATooltip } from 'components/Antd';
import T from 'i18n-react';
import classes from './AddExistingDocumentsModal.module.scss';

const AddExistingDocumentsModal = ({
  open,
  onClose,
  onSubmit,
  existingDocuments,
  existingFiles,
}) => {
  const tExistingDocuments = existingDocuments || [];
  const [search, setSearch] = useState('');
  const [checkAll, setCheckAll] = useState(false);
  const [checks, setChecks] = useState({});
  const checkItems = Object.keys(checks).filter((key) => !!checks[key]);
  const checkItemsLength = checkItems.length;
  const today = getMomentDate('', true);
  const filteredItems = (tList) => {
    return tList.filter((item) =>
      (item.documentList?.name || '').toLowerCase().includes(search.toLowerCase())
    );
  };

  useEffect(() => {
    const newChecks = {};
    existingFiles.forEach((id) => {
      newChecks[id] = true;
    });
    setChecks(newChecks);
  }, []);

  return (
    <>
      <AModal
        title="Add Existing Document"
        open={open}
        onCancel={onClose}
        closable
        width={1000}
        className={cn(classes.modalWrapper)}>
        <div className={classes.mainContent}>
          <div className={classes.searchWrapper}>
            <AInput
              addonBefore={<SearchOutlined />}
              placeholder="Search by document name"
              size="large"
              value={search}
              allowClear
              isSearch
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              className={classes.searchInput}
            />
          </div>
          <div className={classes.listWrapper}>
            <div className={classes.headerWrapper}>
              <div className={cn(classes.row, classes.header)}>
                <span>
                  <ACheckbox
                    checked={checkAll}
                    indeterminate={
                      checkItemsLength > 0 && checkItemsLength < tExistingDocuments.length
                    }
                    onChange={() => {
                      setCheckAll(!checkAll);
                      const newChecks = {};
                      tExistingDocuments.forEach((item) => {
                        const documentObj = item.documentList || {};
                        newChecks[documentObj.id] = !checkAll;
                      });
                      setChecks(newChecks);
                    }}
                  />
                </span>
                <span>Name</span>
                <span>Type</span>
                <span>Review Date</span>
                <span>Expiry Date</span>
                <span>Upload Date</span>
                <span />
              </div>
            </div>
            <div className={classes.listInner}>
              {filteredItems(tExistingDocuments).map((item) => {
                const documentObj = item.documentList || {};
                const reviewStatus = item?.isVerified;
                const verifyNotes = item?.verifyNotes;
                const verifiedByUser = item?.verifiedByUser;
                const verifiedAt = item?.verifiedAt;
                const reviewDateMoment = getMomentDate(documentObj.documentListIndex?.reviewDate);
                const isReviewDateRed =
                  !!reviewDateMoment && reviewDateMoment.isSameOrBefore(today);
                const expiryDateMoment = getMomentDate(documentObj.documentListIndex?.expiryDate);
                const isExpiryDateRed =
                  !!expiryDateMoment && expiryDateMoment.isSameOrBefore(today);
                const previewUrl =
                  documentObj.previewUrl || documentObj.documentListIndex?.previewUrl;
                return (
                  <div className={cn(classes.row, classes.content)} key={documentObj.id}>
                    <span>
                      <ACheckbox
                        checked={checks[documentObj.id]}
                        onChange={() => {
                          setChecks({
                            ...checks,
                            [documentObj.id]: !checks[documentObj.id],
                          });
                        }}
                      />
                    </span>
                    <span>{documentObj.name || '/'}</span>
                    <span>{documentObj.type?.name || '/'}</span>
                    <span
                      style={{
                        color: isReviewDateRed ? '#ED4646' : 'undefined',
                      }}>
                      {getDateWithFormat(
                        documentObj.documentListIndex?.reviewDate,
                        'DD MMM YYYY'
                      ) || '/'}
                    </span>
                    <span
                      style={{
                        color: isExpiryDateRed ? '#ED4646' : 'undefined',
                      }}>
                      {getDateWithFormat(
                        documentObj.documentListIndex?.expiryDate,
                        'DD MMM YYYY'
                      ) || '/'}
                    </span>
                    <span>{getDateWithFormat(documentObj.createdAt, 'DD MMM YYYY') || '/'}</span>
                    <span>
                      {!!reviewStatus && (
                        <ATooltip
                          dark
                          placement="bottomRight"
                          overlayClassName={classes.tooltipOverlay}
                          title={
                            !!reviewStatus && (
                              <span className={classes.reviewStatusContent}>
                                <span>
                                  {reviewStatus === 'accepted'
                                    ? 'Accepted'
                                    : reviewStatus === 'rejected'
                                    ? 'Rejected'
                                    : 'Reviewed'}{' '}
                                  by{' '}
                                  {[verifiedByUser?.firstName, verifiedByUser?.lastName]
                                    .filter((v) => !!v)
                                    .join(' ')}
                                </span>
                                <span>{verifyNotes}</span>
                                <span>{getDateWithFormat(verifiedAt, 'DD MMM YYYY, HH:mm')}</span>
                              </span>
                            )
                          }>
                          <span>
                            {reviewStatus === 'accepted' ? (
                              <ReviewAcceptSvg />
                            ) : reviewStatus === 'rejected' ? (
                              <ReviewRejectSvg />
                            ) : reviewStatus === 'notApplicable' ? (
                              'N/A'
                            ) : (
                              ''
                            )}
                          </span>
                        </ATooltip>
                      )}
                      {!!previewUrl && (
                        <ATooltip
                          dark
                          placement="topRight"
                          overlayClassName={classes.tooltipOverlay}
                          title={'Open in New Browser Tab'}>
                          <span
                            style={{ display: 'flex' }}
                            onClick={() => {
                              const win = window.open(previewUrl, '_blank');
                              win.focus();
                            }}>
                            <ExternalSvg className={classes.externalIcon} />
                          </span>
                        </ATooltip>
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={classes.footer}>
            <AButton
              htmlType="button"
              type="primary"
              size="large"
              className={classes.confirmBtn}
              disabled={checkItemsLength === 0}
              onClick={() => {
                onSubmit(checkItems);
              }}>
              Confirm
            </AButton>
          </div>
        </div>
      </AModal>
    </>
  );
};

export default AddExistingDocumentsModal;
